import { styled } from 'goober';
import { COLORS, hexToRGB } from '@shared/config/colors/colors';
import { Typography } from '../typography/typography';

export const Wrapper = styled('div')`
    width: 100%;
    height: 100%;
    background: linear-gradient(${COLORS.blue}, ${hexToRGB(COLORS.blue, 0.6)});
    border-radius: 50%;
    box-shadow: inset 0px 0px 0px 0.5px ${hexToRGB(COLORS.black, 0.08)};
`;

export const InitialsText = styled(Typography)`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;
